import { render, staticRenderFns } from "./Ques.vue?vue&type=template&id=d9a845de&scoped=true&"
import script from "./Ques.vue?vue&type=script&lang=js&"
export * from "./Ques.vue?vue&type=script&lang=js&"
import style0 from "./Ques.vue?vue&type=style&index=0&id=d9a845de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a845de",
  null
  
)

export default component.exports